/**
 * Generic fetch wrapper with credentials (cookies) for auth endpoints.
 */

const API_BASE = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}`
  : "";

async function request<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const url = `${API_BASE}${path}`;
  const isFormData = options.body instanceof FormData;
  const res = await fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(options.headers ?? {}),
    },
  });

  if (res.status === 204) {
    return undefined as T;
  }

  let data: any = null;
  const contentType = res.headers.get("content-type") ?? "";
  if (contentType.includes("application/json")) {
    try {
      data = await res.json();
    } catch {
      // Response claimed JSON but wasn't parseable
    }
  }

  if (!res.ok) {
    const detail = data?.detail;
    if (detail) throw new Error(detail);
    if (res.status >= 500) {
      throw new Error("服务器暂时不可用，请稍后重试");
    }
    if (res.status === 404) {
      throw new Error("请求的资源不存在");
    }
    throw new Error(`请求失败 (${res.status})`);
  }

  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body: unknown) =>
    request<T>(path, {
      method: "POST",
      body: JSON.stringify(body),
    }),
};
